<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Incident Detail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickClose"
                >
                    Close
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 25px;"
        >
            <m-showdown
                v-if="incident != null"
                :value="incident.details_markdown"
            />
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,
            incident: null,
        }
    },

    methods: {

        showDialog(incident_id)
        {
            this.$rc.showSpinner();
        
            this.$rc.rest(
                'GET: /incidents/:incident_id',
            
                {
                    'incident_id' : incident_id
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.incident = data;

                    this.dialog = true;
                    this.$router.dialog_guard = this.dialogGuard;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get incident details');
                },
            );
        },

        onClickClose()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false);
            return;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>